import {
  Component,
  OnInit,
  EventEmitter,
  ViewContainerRef,
  ElementRef,
} from '@angular/core';
import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { Output } from '@angular/core';
import { AlgGtmService } from '../../../services/alg-gtm.service';
import { Product, ProductType } from '../../../models/product';
import { ApiService } from '../../../services/api.service';
import { Onboarding } from '../../../models/onboarding';
import { ModalDialogService } from 'ngx-modal-dialog';
import { UtilsService } from '../../../services/utils.service';
import { AlgLinearModalComponent } from '../../dialogs/alg-linear-modal/alg-linear-modal.component';
import { Status } from '../../../models/onboarding';
import { environment } from '../../../../environments/environment';
import { declerationLinearText } from '../../../models/contitions';
import { AlgConditionModalComponent } from '../../dialogs/alg-condition-modal/alg-condition-modal.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { debounceTime, take } from 'rxjs/operators';

@Component({
  selector: 'alg-accessories-element',
  templateUrl: './alg-accessories-element.component.html',
  styleUrls: ['./alg-accessories-element.component.scss'],
})
export class AlgAccessoriesElementComponent implements OnInit {
  @Output() statusBack = new EventEmitter<string>();

  public isLight: boolean;
  public isGas: boolean;
  public product: Product;
  public onboarding: Onboarding = {} as Onboarding;
  public optionSwitchGas = false;
  public optionSwitchLight = false;
  public hasBaseDropZoneOver: boolean;
  public uploaderFront: FileUploader;
  public uploaderBack: FileUploader;
  public uploadedDocumentFront: boolean;
  public uploadedDocumentBack: boolean;
  public documentUploadedFront: string;
  public documentUploadedBack: string;
  public overDropFront: boolean;
  public overDropBack: boolean;
  public approvalId: any;
  public insuranceFormGroup: FormGroup = new FormGroup({});
  public goToNextStep: boolean;
  public fileFormatErrorFront: boolean;
  public fileFormatErrorBack: boolean;
  public checkboxDeclareGas: boolean;
  public checkboxInformativeGas: boolean;
  public checkboxDeclareLight: boolean;
  public checkboxInformativeLight: boolean;

  public linearGasInformative =
    'https://s3.eu-central-1.amazonaws.com/documenti.lucegasecoop.it/linear/Set_Informativo_ALG_OpzioneSicura_Gas.pdf';

  public linearLightInformative =
    'https://s3.eu-central-1.amazonaws.com/documenti.lucegasecoop.it/linear/Set_Informativo_ALG_OpzioneSicura_Luce.pdf';

  private gas = {
    gasPolicy: new FormControl(this.onboarding.Alg_GASShowPolicy__c, {
      validators: [Validators.requiredTrue],
    }),
    gasInformative: new FormControl(this.onboarding.informativeSetShowGas, {
      validators: [Validators.requiredTrue],
    }),
  };

  private light = {
    lightPolicy: new FormControl(this.onboarding.Alg_LIGHTInsurancePolicy__c, {
      validators: [Validators.requiredTrue],
    }),
    lightInformative: new FormControl(this.onboarding.informativeSetShowLight, {
      validators: [Validators.requiredTrue],
    }),
  };

  constructor(
    private gtm: AlgGtmService,
    private api: ApiService,
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef,
    private el: ElementRef
  ) {
    this.api.updateDocumentFront$.subscribe((item) => {
      this.uploadedDocumentFront = item;
    });

    this.api.updateDocumentBack$.subscribe((item) => {
      this.uploadedDocumentBack = item;
    });
  }

  ngOnInit() {
    this.api.currentOnboarding
      .combineLatest(this.api.currentProduct)
      .subscribe(([onboarding, product]) => {
        this.genFormControl(product, onboarding);
        this.onboarding = onboarding;
        this.product = product;
        this.approvalId = onboarding._id;
        // CONTROLS IF INSURANCE POLICIES ARE ACTIVE ON INIT
        if (
          !this.onboarding.Alg_GASInsurancePolicy__c &&
          this.product.type === 'Gas'
        ) {
          this.goToNextStep = true;
          this.insuranceFormGroup.clearValidators();
          this.api.updateDocumentFront$.next(true);
          this.api.updateDocumentBack$.next(true);
        }

        if (
          !this.onboarding.Alg_LIGHTInsurancePolicy__c &&
          this.product.type === 'Luce'
        ) {
          this.goToNextStep = true;
          this.insuranceFormGroup.clearValidators();
          this.api.updateDocumentFront$.next(true);
          this.api.updateDocumentBack$.next(true);
        }

        if (
          !this.onboarding.Alg_LIGHTInsurancePolicy__c &&
          !this.onboarding.Alg_GASInsurancePolicy__c &&
          this.product.type === 'Luce & Gas'
        ) {
          this.goToNextStep = true;
          this.insuranceFormGroup.clearValidators();
          this.api.updateDocumentFront$.next(true);
          this.api.updateDocumentBack$.next(true);
        }

        // CONTROLS IF USER COME BACK HERE FROM PREVIOUS STEP
        if (
          this.onboarding.Alg_GASInsurancePolicy__c &&
          this.insuranceFormGroup.status === 'VALID' &&
          this.product.type === 'Gas'
        ) {
          this.goToNextStep = true;
        }

        if (
          this.onboarding.Alg_LIGHTInsurancePolicy__c &&
          this.insuranceFormGroup.status === 'VALID' &&
          this.product.type === 'Luce'
        ) {
          this.goToNextStep = true;
        }

        if (
          this.insuranceFormGroup.status === 'VALID' &&
          this.product.type === 'Luce & Gas'
        ) {
          this.goToNextStep = true;
        }
      });

    const URL = `${environment.api.basePath}/upload-linear-documents/onboarding/${this.approvalId}`;

    this.uploaderFront = new FileUploader({
      url: URL,
      autoUpload: true,
      disableMultipart: false,
      itemAlias: 'linearDocumentFront',
    });
    this.uploaderFront.onBeforeUploadItem = (item) => {
      item.withCredentials = false;
    };

    this.uploaderBack = new FileUploader({
      url: URL,
      disableMultipart: false,
      autoUpload: true,
      itemAlias: 'linearDocumentBack',
    });
    this.uploaderBack.onBeforeUploadItem = (item) => {
      item.withCredentials = false;
    };

    this.insuranceFormGroup.statusChanges.subscribe((status) => {
      if (status === 'VALID') {
        this.allowNextStep();
      } else {
        this.goToNextStep = false;
      }
    });
  }

  private genFormControl(product: Product, onboarding: Onboarding) {
    this.product = product;
    let fields = {};
    if (product.type === ProductType.luce) {
      this.isLight = true;
      if (onboarding.Alg_LIGHTInsurancePolicy__c) {
        fields = {
          ...fields,
          ...this.light,
        };
      }
    }
    if (product.type === ProductType.gas) {
      this.isGas = true;
      if (onboarding.Alg_GASInsurancePolicy__c) {
        fields = {
          ...fields,
          ...this.gas,
        };
      }
    }
    if (product.type === ProductType.luceEgas) {
      this.isLight = true;
      this.isGas = true;
      if (
        onboarding.Alg_GASInsurancePolicy__c &&
        onboarding.Alg_LIGHTInsurancePolicy__c
      ) {
        fields = {
          ...fields,
          ...this.gas,
          ...this.light,
        };
      }

      if (
        onboarding.Alg_GASInsurancePolicy__c &&
        !onboarding.Alg_LIGHTInsurancePolicy__c
      ) {
        fields = {
          ...fields,
          ...this.gas,
        };
      }

      if (
        !onboarding.Alg_GASInsurancePolicy__c &&
        onboarding.Alg_LIGHTInsurancePolicy__c
      ) {
        fields = {
          ...fields,
          ...this.light,
        };
      }
    }

    this.insuranceFormGroup = new FormGroup({ ...fields });
  }

  changeStatus(value) {
    this.gtm.submitOnbEvent('clic su indietro', 'payment');
    this.statusBack.emit(value);
  }

  changeSwitchOption(value, event) {
    switch (value) {
      case 'gas':
        this.onboarding.Alg_GASInsurancePolicy__c =
          !this.onboarding.Alg_GASInsurancePolicy__c;
        if (event === true) {
          this.insuranceFormGroup.addControl(
            'gasPolicy',
            new FormControl(this.onboarding.Alg_GASShowPolicy__c, {
              validators: [Validators.requiredTrue],
            })
          );
          this.insuranceFormGroup.addControl(
            'gasInformative',
            new FormControl(this.onboarding.informativeSetShowGas, {
              validators: [Validators.requiredTrue],
            })
          );
          this.goToNextStep = false;
          if (this.onboarding.Alg_LIGHTInsurancePolicy__c) {
            if (!this.uploadedDocumentFront && !this.uploadedDocumentBack) {
              this.api.updateDocumentFront$.next(false);
              this.api.updateDocumentBack$.next(false);
            } else {
              this.api.updateDocumentFront$.next(true);
              this.api.updateDocumentBack$.next(true);
            }
          } else {
            this.api.updateDocumentFront$.next(false);
            this.api.updateDocumentBack$.next(false);
          }
        } else {
          this.insuranceFormGroup.removeControl('gasPolicy');
          this.insuranceFormGroup.removeControl('gasInformative');
          this.onboarding.Alg_GASShowPolicy__c = false;
          this.onboarding.informativeSetShowGas = false;
          if (!this.onboarding.Alg_LIGHTInsurancePolicy__c) {
            this.goToNextStep = true;
            this.api.updateDocumentFront$.next(false);
            this.api.updateDocumentBack$.next(false);
          }
          if (this.onboarding.Alg_LIGHTInsurancePolicy__c) {
            if (this.uploadedDocumentBack && this.uploadedDocumentFront) {
              this.api.updateDocumentFront$.next(true);
              this.api.updateDocumentBack$.next(true);
            }
          }
        }
        break;

      case 'light':
        this.onboarding.Alg_LIGHTInsurancePolicy__c =
          !this.onboarding.Alg_LIGHTInsurancePolicy__c;
        if (event === true) {
          this.insuranceFormGroup.addControl(
            'lightPolicy',
            new FormControl(this.onboarding.Alg_LIGHTShowPolicy__c, {
              validators: [Validators.requiredTrue],
            })
          );
          this.insuranceFormGroup.addControl(
            'lightInformative',
            new FormControl(this.onboarding.informativeSetShowLight, {
              validators: [Validators.requiredTrue],
            })
          );
          this.goToNextStep = false;
          if (this.onboarding.Alg_GASInsurancePolicy__c) {
            if (!this.uploadedDocumentFront && !this.uploadedDocumentBack) {
              this.api.updateDocumentFront$.next(false);
              this.api.updateDocumentBack$.next(false);
            } else {
              this.api.updateDocumentFront$.next(true);
              this.api.updateDocumentBack$.next(true);
            }
          } else {
            this.api.updateDocumentFront$.next(false);
            this.api.updateDocumentBack$.next(false);
          }
        } else {
          this.insuranceFormGroup.removeControl('lightPolicy');
          this.insuranceFormGroup.removeControl('lightInformative');
          this.onboarding.Alg_LIGHTShowPolicy__c = false;
          this.onboarding.informativeSetShowLight = false;
          if (!this.onboarding.Alg_GASInsurancePolicy__c) {
            this.goToNextStep = true;
            this.api.updateDocumentFront$.next(false);
            this.api.updateDocumentBack$.next(false);
          }
          if (this.onboarding.Alg_GASInsurancePolicy__c) {
            if (this.uploadedDocumentBack && this.uploadedDocumentFront) {
              this.api.updateDocumentFront$.next(true);
              this.api.updateDocumentBack$.next(true);
            }
          }
        }
        break;
    }
  }

  uploadDocument(type) {
    switch (type) {
      case 'front':
        (<HTMLInputElement>document.getElementById('frontDocument')).click();
        break;

      case 'back':
        (<HTMLInputElement>document.getElementById('backDocument')).click();
        break;
    }
  }

  openModalIncludes(type) {
    switch (type) {
      case 'gas':
        this.openModal('gas');
        this.gtm.submitIncludeEvent('cosa include - gas');
        break;
      case 'light':
        this.openModal('light');
        this.gtm.submitIncludeEvent('cosa include - luce');
        break;
    }
  }

  openModal(type) {
    this.utils.disableOverflow();
    let titolo = '';
    if (type === 'gas') {
      titolo = 'Cosa include Opzione Sicura Gas';
    }
    if (type === 'light') {
      titolo = 'Cosa include Opzione Sicura Luce';
    }
    this.modalDialogService.openDialog(this.viewContainer, {
      title: titolo,
      childComponent: AlgLinearModalComponent,
      settings: {
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: ' modal-title modal-title-underline',
        modalClass: 'modal fade ngx-modal alternative-modal',
        footerClass: 'example',
        contentClass: 'modal-content included-linear-modal',
      },
      data: {
        description: type,
      },
    });
  }

  declerationChecks(value, type, event) {
    switch (type) {
      case 'gas':
        if (value === 'declare') {
          this.onboarding.Alg_GASShowPolicy__c =
            !this.onboarding.Alg_GASShowPolicy__c;
          this.checkboxDeclareGas = !this.onboarding.Alg_GASShowPolicy__c;
          this.insuranceFormGroup.addControl(
            'gasPolicy',
            new FormControl(this.onboarding.Alg_GASShowPolicy__c, {
              validators: [Validators.requiredTrue],
            })
          );
        }
        if (value === 'informative') {
          this.onboarding.informativeSetShowGas =
            !this.onboarding.informativeSetShowGas;
          this.checkboxInformativeGas = !this.onboarding.informativeSetShowGas;
          this.insuranceFormGroup.addControl(
            'gasInformative',
            new FormControl(this.onboarding.informativeSetShowGas, {
              validators: [Validators.requiredTrue],
            })
          );
        }
        break;

      case 'light':
        if (value === 'declare') {
          this.onboarding.Alg_LIGHTShowPolicy__c =
            !this.onboarding.Alg_LIGHTShowPolicy__c;
          this.checkboxDeclareLight = !this.onboarding.Alg_LIGHTShowPolicy__c;
          this.insuranceFormGroup.addControl(
            'lightPolicy',
            new FormControl(this.onboarding.Alg_LIGHTShowPolicy__c, {
              validators: [Validators.requiredTrue],
            })
          );
        }
        if (value === 'informative') {
          this.onboarding.informativeSetShowLight =
            !this.onboarding.informativeSetShowLight;
          this.checkboxInformativeLight =
            !this.onboarding.informativeSetShowLight;
          this.insuranceFormGroup.addControl(
            'lightInformative',
            new FormControl(this.onboarding.informativeSetShowLight, {
              validators: [Validators.requiredTrue],
            })
          );
        }
        break;
    }
    this.allowNextStep();
  }

  droppedFile(event, type) {
    switch (type) {
      case 'front':
        this.documentUploadedFront = event[0].name;
        if (
          event[0].type === 'image/png' ||
          event[0].type === 'image/jpeg' ||
          event[0].type === 'image/jpg' ||
          event[0].type === 'application/pdf'
        ) {
          this.api.updateDocumentFront$.next(true);
          this.fileFormatErrorFront = false;
        } else {
          this.fileFormatErrorFront = true;
        }
        break;

      case 'back':
        this.documentUploadedBack = event[0].name;
        if (
          event[0].type === 'image/png' ||
          event[0].type === 'image/jpeg' ||
          event[0].type === 'image/jpg' ||
          event[0].type === 'application/pdf'
        ) {
          this.api.updateDocumentBack$.next(true);
          this.fileFormatErrorBack = false;
        } else {
          this.fileFormatErrorBack = true;
        }
        break;
    }
    this.allowNextStep();
  }

  selectedFile(event, type) {
    switch (type) {
      case 'front':
        this.documentUploadedFront = event[0].name;
        if (
          event[0].type === 'image/png' ||
          event[0].type === 'image/jpeg' ||
          event[0].type === 'image/jpg' ||
          event[0].type === 'application/pdf'
        ) {
          this.api.updateDocumentFront$.next(true);
        }
        break;

      case 'back':
        this.api.updateDocumentBack$.next(true);
        if (
          event[0].type === 'image/png' ||
          event[0].type === 'image/jpeg' ||
          event[0].type === 'image/jpg' ||
          event[0].type === 'application/pdf'
        ) {
          this.uploadedDocumentBack = true;
        }
        break;
    }
    this.allowNextStep();
  }

  fileOverBase(event, type) {
    switch (type) {
      case 'front':
        this.overDropFront = event;
        break;
      case 'back':
        this.overDropBack = event;
    }
  }

  readCondition(type, secondType) {
    let modalContent;

    switch (type) {
      case 'gas':
        if (secondType === 'informative') {
          modalContent = declerationLinearText.gas;
        }
        if (secondType === 'clausole') {
          modalContent = declerationLinearText.clausoleGas;
        }
        this.openModalOptions(modalContent || {});
        break;

      case 'light':
        if (secondType === 'informative') {
          modalContent = declerationLinearText.light;
        }
        if (secondType === 'clausole') {
          modalContent = declerationLinearText.clausoleGas;
        }
        this.openModalOptions(modalContent || {});
        break;
    }
  }

  openModalOptions(modalContent) {
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: modalContent.title,
      childComponent: AlgConditionModalComponent,
      settings: {
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: ' modal-title modal-title-underline',
      },
      data: {
        description: modalContent.description,
      },
    });
  }

  private allowNextStep() {
    if (this.insuranceFormGroup.status === 'VALID') {
      this.goToNextStep =
        this.uploadedDocumentBack && this.uploadedDocumentFront;
    }
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach((control) => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  private scrollOnInvalidElement(invalidControl) {
    window.scroll({
      top: this.getTopOffset(invalidControl),
      left: 0,
      behavior: 'smooth',
    });

    fromEvent(window, 'scroll')
      .pipe(debounceTime(100), take(1))
      .subscribe(() => {
        invalidControl.firstElementChild.focus();
      });
  }

  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 50;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }

  nextStep() {
    this.markFormGroupTouched(this.insuranceFormGroup);
    const invalidControl =
      this.el.nativeElement.querySelector('form .ng-invalid');
    if (invalidControl) {
      this.scrollOnInvalidElement(invalidControl);
      if (this.onboarding.Alg_GASInsurancePolicy__c) {
        this.checkboxDeclareGas = !this.onboarding.Alg_GASShowPolicy__c;
        this.checkboxInformativeGas = !this.onboarding.informativeSetShowGas;
      }
      if (this.onboarding.Alg_LIGHTInsurancePolicy__c) {
        this.checkboxDeclareLight = !this.onboarding.Alg_LIGHTShowPolicy__c;
        this.checkboxInformativeLight =
          !this.onboarding.informativeSetShowLight;
      }
    }
    if (this.goToNextStep) {
      this.statusBack.emit('current');
      delete this.onboarding.linearDocumentFront;
      delete this.onboarding.linearDocumentBack;
      this.api.nextStep(this.onboarding, Status.insurance);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/steps/alg-accessories-element/alg-accessories-element.component.ts